export const getStyled = (theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: 240,
  },

  cardAvatar: {
    fontSize: '55px',
    //color: grey[500],
    backgroundColor: '#ffffff',
    width: theme.spacing(7),
    height: theme.spacing(7),
  },

  cardTitle: {
    fontSize: '18px',
    //color: blue[700],
  },

  cardSubtitle: {
    //color: grey[600],
    fontSize: '14px',
  },

  alignRight: {
    textAlign: 'right',
  },

  fullWidth: {
    width: '100%',
  },

  selectContainer: {
    width: '100%',
    textAlign: 'left',
  },

  tab: {
    backgroundColor: theme.custom.colors.defaultBackground,
    borderRadius: 4,
    cursor: 'pointer',
    width: '100%',
    transition: 'all 0.3s ease',
    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },

    '&:hover': {
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
  },

  checkBox: {
    transform: 'scale(0.8)',
  },
});
